import { SelectOption } from '@/components/Form/src/types'
import { rotationEnum } from './rotationEnum'

const statusOption: SelectOption[] = [
  {
    value: rotationEnum.Status.Submitted,
    label: 'Submitted'
  },
  {
    value: rotationEnum.Status.RecommendedByAdmin,
    label: 'Recommended'
  },
  {
    value: rotationEnum.Status.RecommendedBySupervisor,
    label: 'Recommended'
  },
  {
    value: rotationEnum.Status.NotRecommendedByAdmin,
    label: 'Not Recommended'
  },
  {
    value: rotationEnum.Status.NotRecommendedBySupervisor,
    label: 'Not Recommended'
  }
]

const adminRotationStatusOption: SelectOption[] = [
  {
    value: rotationEnum.Status.Submitted,
    label: 'Submitted by Trainee'
  },
  // {
  //   value: rotationEnum.Status.Resbumitted,
  //   label: 'Re-sbumitted by Trainee'
  // },
  {
    value: rotationEnum.Status.RecommendedByAdmin,
    label: 'Recommended'
  },
  {
    value: rotationEnum.Status.NotRecommendedByAdmin,
    label: 'Not Recommended'
  }
]

const learningStatusOption: SelectOption[] = [
  {
    label: 'Submitted by Trainee',
    value: rotationEnum.LearningPortfolioStatus.Submitted
  },
  {
    label: 'Endorsed by Supervisor',
    value: rotationEnum.LearningPortfolioStatus.EndorsedBySupervisor
  },
  {
    label: 'Reject by Supervisor',
    value: rotationEnum.LearningPortfolioStatus.RejectBySupervisor
  }
]

const trainingDairyStatusOption: SelectOption[] = [
  {
    label: 'Submitted by Trainee',
    value: rotationEnum.LogDairyStatus.Submitted
  },
  {
    label: 'Endorsed by Supervisor',
    value: rotationEnum.LogDairyStatus.EndorsedBySupervisor
  },
  {
    label: 'Reject by Supervisor',
    value: rotationEnum.LogDairyStatus.RejecttedBySupervisor
  }
]

const assessmentStatusOption: SelectOption[] = [
  {
    label: 'Saved',
    value: rotationEnum.AssessmentStatus.Saved
  },
  {
    label: 'Completed',
    value: rotationEnum.AssessmentStatus.Completed
  }
]

const typeOptions: SelectOption[] = [
  {
    label: 'Rotation',
    value: rotationEnum.Type.Rotation
  },
  {
    label: 'Past Local Rotation',
    value: rotationEnum.Type.PastLocalRotation
  },
  {
    label: 'Past Overseas Rotation',
    value: rotationEnum.Type.PastOverseasRotation
  }
]

export const rotationOption = {
  statusOption,
  adminRotationStatusOption,
  assessmentStatusOption,
  learningStatusOption,
  trainingDairyStatusOption,
  typeOptions
}
